export default __webpack_public_path__ + "static/media/Logo2.f56192ac.png";